import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  button: {
    minWidth: 130,
    fontSize: theme.fontSizes.onboarding,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

interface Props {
  nextButtonText: string;
}

export default function NextButton({ nextButtonText }: Props) {
  const classes = useStyles();

  const BUTTON_TEXT = nextButtonText || 'Next';

  return (
    <Button
      className={classes.button}
      color="primary"
      variant="contained"
      type="submit"
      data-automation-id="submit"
    >
      {BUTTON_TEXT}
    </Button>
  );
}
